module.exports = __webpack_public_path__ + "static/venti-banner-914cf67888449b943c5f586a611dae5d.png";